module.exports = __webpack_public_path__ + "static/img/bullhorn.f74a540.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bullhorn.svg
// module id = wyza
// module chunks = 1